import { createAsyncThunk } from '@reduxjs/toolkit';
import { SharingPermissions } from 'scribe-web-shared/types/document';

import * as sharingPermissionsService from '../../services/sharingPermissionsService';

/**
 * @deprecated Use or modify `useSharingPermissions` from `hooks/file/useFileSharingPermissions` instead.
 *
 * Fetches the sharing permissions for a document and updates redux.
 */
export const fetchSharingPermissionsForDocument = createAsyncThunk(
  'sharingPermissions/fetchSharingPermissionsForDocument',
  async ({ documentId }: { documentId: string }) => {
    return (await sharingPermissionsService.fetchForDocumentMetadata(documentId)) as SharingPermissions;
  }
);
